import { boolean, string, z } from 'zod';
import { ContributionsTypesEnum } from './contributions';
import { datetime } from './commons';
//============================================
// ENUM
//============================================
export var SollicitationsTypes;
(function (SollicitationsTypes) {
    SollicitationsTypes["COMPLEMENTS"] = "complements";
    SollicitationsTypes["PIECES"] = "pieces";
    SollicitationsTypes["JUSTIFICATIONS"] = "justifications";
    SollicitationsTypes["AVIS_PREALABLES"] = "avis-prealables";
    SollicitationsTypes["AVIS"] = "avis";
    SollicitationsTypes["ATTESTATIONS"] = "attestations";
    SollicitationsTypes["SHARED_DEMANDE_PAIEMENT"] = "shared-demande-paiement";
    SollicitationsTypes["SHARED_CONTRIBUTION"] = "shared-contribution";
})(SollicitationsTypes || (SollicitationsTypes = {}));
export var JustificationsStatuses;
(function (JustificationsStatuses) {
    JustificationsStatuses["REQUESTED"] = "REQUESTED";
    JustificationsStatuses["NEED_UPDATE"] = "NEED_UPDATE";
})(JustificationsStatuses || (JustificationsStatuses = {}));
export var JustificationTypes;
(function (JustificationTypes) {
    JustificationTypes["NON_REALISATION_ACTION"] = "NRA";
    JustificationTypes["COMPTE_RENDU_FINANCIER"] = "CRF";
})(JustificationTypes || (JustificationTypes = {}));
export const JustificationActionsIconsMapping = {
    justificationDeleteBtn: 'trash',
    DeposerDemandeReportButton: 'clock-outline',
    default: 'pen',
};
//====================================================
// Sollicitations actions enum
//====================================================
export const SollicitationsActions = {
    COMPLETE_MODIFICATION: 'complete-modification',
    COMPLETE_REDIRECTION: 'complete-redirection',
    SHARE_CONTRIBUTION: 'share-contribution',
};
export const SollicitationsActionsEnum = z.nativeEnum(SollicitationsActions);
//====================================================
// Actions
//====================================================
export const SollicitationActionSchema = z.object({
    id: z.string(),
    title: z.string(),
    variant: z.string().optional(),
    disabled: z.boolean().optional(),
    icon: z.object({ icon: z.string(), spin: boolean().optional() }).optional(),
    badge: z
        .object({
        value: z.number().or(z.string()),
        label: z.string(),
        outline: z.boolean().optional(),
        variant: z.string().optional(),
    })
        .optional(),
});
export const SollicitationActionsSchema = z.array(SollicitationActionSchema);
//============================================
// FROM BACK
//============================================
export const ComplementsSchema = z.object({
    id: z.string(),
    dateEnvoi: z.string(),
    reference: z.string(),
    type: z.literal(SollicitationsTypes.COMPLEMENTS),
    typeContribution: ContributionsTypesEnum,
    statut: z.string(),
    teleservice: z
        .object({
        reference: z.string(),
        title: z.string().optional(),
    })
        .optional(),
    demande: z.object({
        id: string(),
        reference: string(),
        referenceAdministrative: z.string(),
        title: z.string(),
        teleservice: z.object({
            reference: z.string(),
            title: z.string(),
        }),
        comiteRecevabilite: z
            .object({
            dateDeComite: z.string().optional(),
            libelle: z.string(),
        })
            .optional(),
    }),
    actions: z.array(z.object({
        type: z.string(),
        count: z.number().optional(),
    })),
});
const DcpDemandeFinancementSchema = z.object({
    date: datetime,
    reference: z.string(),
    referenceAdministrative: z.string(),
    type: z.literal(SollicitationsTypes.PIECES),
    teleservice: z.object({
        reference: z.string(),
        href: z.string(),
        title: z.string(),
    }),
    id: z.string(),
    justification: z.object({ statut: z.string().optional() }),
    title: z.string(),
    avisPrealables: z.array(z.object({})).optional(),
    status: z.string(),
    dateDemandeComplementPiece: z.string().optional(),
    demandeComplementPieces: z.object({
        avancement: z.string(),
        dateDemande: z.string().optional(),
        href: z.string(),
    }),
});
const DcpDemandePaiementSchema = z.object({
    demande: z.object({
        id: z.string(),
        reference: string(),
        referenceAdministrative: z.string(),
        title: z.string(),
    }),
    title: z.string(),
    reference: z.string(),
    id: z.string(),
    type: z.literal(SollicitationsTypes.PIECES),
    dateDemandeComplementPiece: z.string().optional(),
    demandeComplementPieces: z.object({
        avancement: z.string(),
        dateDemande: z.string().optional(),
        id: z.number(),
    }),
});
export const DcpSchema = z.union([DcpDemandeFinancementSchema, DcpDemandePaiementSchema]);
export const SharedDemandePaiementSollicitationsSchema = z.object({
    type: z.literal(SollicitationsTypes.SHARED_DEMANDE_PAIEMENT),
    demande: z.object({
        id: z.string(),
        reference: string(),
        referenceAdministrative: z.string(),
        title: z.string(),
    }),
    id: z.string(),
    reference: z.string(),
    title: z.string(),
    date: z.string(),
    teleservicePaiementReference: z.string(),
    dossier: z.object({
        reference: string(),
        referenceAdministrative: z.string().optional(),
        title: z.string(),
    }),
    financeurHref: z.string().optional(),
});
export const SharedContributionSollicitationsSchema = z.object({
    type: z.literal(SollicitationsTypes.SHARED_CONTRIBUTION),
    demande: z.object({
        id: z.string(),
        reference: string(),
        referenceAdministrative: z.string(),
        title: z.string(),
        teleservice: z.object({
            reference: z.string(),
            title: z.string(),
        }),
    }),
    id: z.string(),
    reference: z.string(),
    title: z.string(),
    date: z.string(),
    teleservice: z
        .object({
        reference: z.string(),
        title: z.string(),
    })
        .optional(),
    typeContribution: z.string(),
});
export const SharedSollicitationsSchema = z.union([
    SharedDemandePaiementSollicitationsSchema,
    SharedContributionSollicitationsSchema,
]);
const AvisSchema = z.object({
    dateEnvoi: z.string(),
    reference: z.string(),
    typeContribution: z.string(),
    statut: z.string(),
    teleservice: z.object({
        reference: z.string(),
        title: z.string().optional(),
    }),
    demande: z.object({
        reference: string(),
        referenceAdministrative: z.string(),
        title: z.string(),
        teleservice: z.object({
            reference: z.string(),
            title: z.string(),
        }),
        comiteRecevabilite: z
            .object({
            dateDeComite: z.string().optional(),
            libelle: z.string(),
        })
            .optional(),
        beneficiaires: z.array(z.object({
            href: z.string(),
            title: z.string(),
            fullName: z.string().optional(),
        })),
    }),
    tiers: z.object({
        href: z.string(),
        title: z.string(),
    }),
    avis: z
        .object({
        valeur: z.string(),
    })
        .optional(),
    cloture: z
        .object({
        value: z.boolean(),
    })
        .optional(),
});
const AvisCompletedSchema = z.object({
    dateEnvoi: z.string(),
    dateReponse: z.string().optional(),
    reference: z.string(),
    typeContribution: z.string(),
    statut: z.string(),
    teleservice: z.object({
        reference: z.string(),
        title: z.string().optional(),
    }),
    demande: z.object({
        reference: string(),
        referenceAdministrative: z.string(),
        title: z.string(),
        teleservice: z.object({
            reference: z.string(),
            title: z.string(),
        }),
        beneficiaires: z.array(z.object({
            href: z.string(),
            title: z.string(),
            fullName: z.string().optional(),
        })),
        comiteRecevabilite: z
            .object({
            dateDeComite: z.string().optional(),
            libelle: z.string(),
        })
            .optional(),
    }),
    tiers: z.object({
        href: z.string(),
        title: z.string(),
    }),
    avis: z.object({
        valeur: z.string(),
    }),
    cloture: z
        .object({
        value: z.boolean(),
    })
        .optional(),
});
const AvisPrealablesSchema = z.object({
    date: datetime,
    registeredDate: datetime,
    hasBeenRegistered: z.boolean(),
    title: z.string(),
    reference: z.string(),
    referenceAdministrative: z.string(),
    teleservice: z.object({
        reference: z.string(),
        href: z.string(),
        title: z.string(),
    }),
    id: z.string(),
    justification: z.object({}),
    demandesComplementPieces: z.array(z.object({})),
    user: z.object({
        title: z.string(),
    }),
    status: z.string(),
    avisPrealable: z.object({
        tiers: z.object({
            mail: z.string(),
            href: z.string(),
            title: z.string(),
        }),
    }),
    beneficiaires: z.array(z.object({
        href: z.string(),
        title: z.string(),
        fullName: z.string().optional(),
    })),
});
const AvisPrealablesCompletedSchema = z.object({
    date: datetime,
    registeredDate: datetime,
    hasBeenRegistered: z.boolean(),
    title: z.string(),
    reference: z.string(),
    referenceAdministrative: z.string(),
    teleservice: z.object({
        reference: z.string(),
        href: z.string(),
        title: z.string(),
    }),
    id: z.string(),
    justification: z.object({}),
    demandesComplementPieces: z.array(z.object({})),
    user: z.object({
        title: z.string(),
    }),
    status: z.string(),
    avisPrealable: z.object({
        date: datetime,
        tiers: z.object({
            mail: z.string(),
            href: z.string(),
            title: z.string(),
        }),
        avis: z.string(),
        commentaire: z.string(),
        user: z.object({
            href: z.string(),
            title: z.string(),
        }),
    }),
    beneficiaires: z.array(z.object({
        href: z.string(),
        title: z.string(),
        fullName: z.string().optional(),
    })),
});
export const JustificationsSchema = z.object({
    id: z.string(),
    reference: z.string(),
    referenceAdministrative: z.string(),
    type: z.literal(SollicitationsTypes.JUSTIFICATIONS),
    date: datetime,
    title: z.string(),
    statut: z.string().optional(),
    kind: z.string().optional(),
    teleservice: z
        .object({
        reference: z.string(),
        title: z.string().optional(),
        justification: z.object({
            teleservices: z.array(z.object({
                title: z.string(),
                href: z.string(),
                justificationType: z.string(),
            })),
        }),
    })
        .optional(),
    justification: z.object({
        statut: z.string(),
        title: z.string().optional(),
        href: z.string().optional(),
        reference: z.string().optional(),
        kind: z.string().optional(),
        teleservice: z
            .object({
            title: z.string(),
        })
            .optional(),
        history: z
            .object({
            begin: z.object({
                date: z.string().optional(),
                user: z.object({
                    title: z.string(),
                    href: z.string(),
                }),
            }),
        })
            .optional(),
    }),
    justificationDate: datetime,
    isDemandeReportAvailable: z.boolean(),
    isEditionAvailable: z.boolean().optional(),
    demande: z
        .object({
        href: z.string(),
        referenceAdministrative: z.string(),
        title: z.string().optional(),
        comiteRecevabilite: z
            .object({
            dateDeComite: z.string().optional(),
            libelle: z.string(),
        })
            .optional(),
    })
        .optional(),
});
const AttestationsSchema = z.object({
    date: datetime,
    demandesComplementPieces: z.array(z.object({})),
    hasBeenWaitingForCertificate: z.boolean(),
    id: z.string(),
    justification: z.object({}),
    reference: z.string(),
    referenceAdministrative: z.string(),
    status: z.string(),
    teleservice: z.object({
        href: z.string(),
        reference: z.string(),
        title: z.string(),
    }),
    title: z.string(),
    waitingForCertificateDate: datetime,
    signataire: z.object({
        href: z.string(),
    }),
    user: z.object({
        title: z.string(),
    }),
    avisPrealables: z.array(z.object({})),
});
const FormattedSollicitationWithDemandeFinancementSchema = z.object({
    id: z.string().optional(),
    reference: z.string(),
    title: z.string(),
    forItem: z.string(),
    date: z.string().optional(),
    dateEnvoi: z.string().optional(),
    icon: z.object({ icon: z.string() }),
    actions: SollicitationActionsSchema,
    demande: z.object({
        id: z.string().optional(),
        title: z.string(),
        reference: z.string(),
        href: z.string().optional(),
        referenceAdministrative: z.string().optional(),
        comiteRecevabilite: z
            .object({
            dateDeComite: z.string().optional(),
            libelle: z.string(),
        })
            .optional(),
    }),
    type: z.string(),
    beneficiaire: z.string().optional(),
});
export const FormattedComplementsSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    id: z.string(),
    teleservice: z.object({
        reference: z.string(),
    }),
    type: z
        .literal(SollicitationsTypes.COMPLEMENTS)
        .or(z.literal(SollicitationsTypes.SHARED_CONTRIBUTION))
        .or(z.literal(SollicitationsTypes.SHARED_DEMANDE_PAIEMENT)),
});
export const FormattedDcpSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    demandePaiement: z
        .object({
        title: z.string(),
        forItem: z.string().optional(),
    })
        .optional(),
    type: z.literal(SollicitationsTypes.PIECES),
});
export const FormattedDemandePaiementSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    demandePaiement: z.object({
        title: z.string(),
        reference: z.string(),
    }),
    teleservicePaiement: z.object({
        reference: z.string(),
    }),
    dossier: z.object({
        reference: string(),
        referenceAdministrative: z.string().optional(),
        title: z.string(),
    }),
    financeurHref: z.string().optional(),
    type: z.literal(SollicitationsTypes.SHARED_DEMANDE_PAIEMENT),
});
const FormattedAvisSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    teleservice: z.object({
        reference: z.string(),
    }),
    teleserviceContribution: z.object({
        reference: z.string(),
    }),
    avis: z
        .object({
        valeur: z.string(),
    })
        .optional(),
    tiers: z.object({
        href: z.string(),
        title: z.string(),
    }),
    type: z.literal(SollicitationsTypes.AVIS),
});
const FormattedAvisCompletedSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    teleservice: z.object({
        reference: z.string(),
    }),
    teleserviceContribution: z.object({
        reference: z.string(),
    }),
    titleFirstDate: datetime,
    dateAvis: z.string().optional(),
    titleAvisDate: datetime,
    tag: z.object({
        variant: z.string(),
        content: z.string(),
    }),
    avis: z.object({
        valeur: z.string(),
    }),
    tiers: z.object({
        href: z.string(),
        title: z.string(),
    }),
    type: z.literal(SollicitationsTypes.AVIS),
});
const FormattedAvisPrealablesSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    teleservice: z.object({
        reference: z.string(),
    }),
    type: z.literal(SollicitationsTypes.AVIS_PREALABLES),
});
const FormattedAvisPrealablesCompletedSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    teleservice: z.object({
        reference: z.string(),
    }),
    titleFirstDate: z.string(),
    dateAvis: z.string(),
    titleAvisDate: z.string(),
    tag: z.object({
        variant: z.string(),
        content: z.string(),
    }),
    type: z.literal(SollicitationsTypes.AVIS_PREALABLES),
});
const FormattedAttestationsSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    demande: z.object({
        title: z.string(),
        reference: z.string(),
        id: z.string(),
    }),
    user: z
        .object({
        title: z.string(),
        forItem: z.string(),
    })
        .optional(),
    type: z.literal(SollicitationsTypes.ATTESTATIONS),
});
export const FormattedJustificationsSchema = FormattedSollicitationWithDemandeFinancementSchema.extend({
    icon: z.object({ icon: z.string() }),
    teleservicesTypes: z.array(z.string()),
    isDemandeReportAvailable: z.boolean(),
    isJustificationRequested: z.boolean(),
    isUserCreator: z.boolean(),
    demandeTitle: z.string(),
    teleservice: z
        .object({
        reference: z.string(),
        href: z.string().optional(),
        title: z.string().optional(),
        justification: z
            .object({
            active: z.boolean().optional(),
            teleservices: z.array(z.object({
                title: z.string(),
                href: z.string(),
                justificationType: z.string(),
            })),
        })
            .optional(),
    })
        .optional(),
    justification: z.object({
        reference: z.string().optional(),
        userTitle: z.string().optional(),
        type: z.string().optional(),
        date: z.string().optional(),
    }),
    type: z.literal(SollicitationsTypes.JUSTIFICATIONS),
});
const SollicitationsComplementsSchema = z.object({
    type: z.literal(SollicitationsTypes.COMPLEMENTS),
    total: z.object({ awaiting: z.number().or(z.string()), completed: z.number().or(z.string()) }),
    awaitingActions: z.array(ComplementsSchema),
    completedActions: z.array(z.object({})),
});
const FormattedSollicitationsComplementsSchema = SollicitationsComplementsSchema.extend({
    awaitingActions: z.array(FormattedComplementsSchema),
});
const SollicitationsDcpSchema = z.object({
    type: z.literal(SollicitationsTypes.PIECES),
    total: z.object({ awaiting: z.number().or(z.string()), completed: z.number().or(z.string()) }),
    awaitingActions: z.array(DcpSchema),
    completedActions: z.array(z.object({})),
});
const FormattedSollicitationsDcpSchema = SollicitationsDcpSchema.extend({
    awaitingActions: z.array(FormattedDcpSchema),
});
const SollicitationsAvisSchema = z.object({
    type: z.literal(SollicitationsTypes.AVIS),
    total: z.object({ awaiting: z.number().or(z.string()), completed: z.number().or(z.string()) }),
    awaitingActions: z.array(AvisSchema),
    completedActions: z.array(AvisCompletedSchema),
});
const FormattedSollicitationsAvisSchema = SollicitationsAvisSchema.extend({
    awaitingActions: z.array(FormattedAvisSchema),
    completedActions: z.array(FormattedAvisCompletedSchema),
});
const SollicitationsAvisPrealablesSchema = z.object({
    type: z.literal(SollicitationsTypes.AVIS_PREALABLES),
    total: z.object({ awaiting: z.number().or(z.string()), completed: z.number().or(z.string()) }),
    awaitingActions: z.array(AvisPrealablesSchema),
    completedActions: z.array(AvisPrealablesCompletedSchema),
});
const FormattedSollicitationsAvisPrealablesSchema = SollicitationsAvisPrealablesSchema.extend({
    awaitingActions: z.array(FormattedAvisPrealablesSchema),
    completedActions: z.array(FormattedAvisPrealablesCompletedSchema),
});
const SollicitationsAttestationsSchema = z.object({
    type: z.literal(SollicitationsTypes.ATTESTATIONS),
    total: z.object({ awaiting: z.number().or(z.string()), completed: z.number().or(z.string()) }),
    awaitingActions: z.array(AttestationsSchema),
    completedActions: z.array(z.object({})),
});
const FormattedSollicitationsAttestationsSchema = SollicitationsAttestationsSchema.extend({
    awaitingActions: z.array(FormattedAttestationsSchema),
});
const SollicitationsJustificationsSchema = z.object({
    type: z.literal(SollicitationsTypes.JUSTIFICATIONS),
    total: z.object({ awaiting: z.number().or(z.string()), completed: z.number().or(z.string()) }),
    awaitingActions: z.array(JustificationsSchema),
    completedActions: z.array(z.object({})),
});
const FormattedSollicitationsJustificationsSchema = SollicitationsJustificationsSchema.extend({
    awaitingActions: z.array(FormattedJustificationsSchema),
});
export const SollicitationsSchema = z.discriminatedUnion('type', [
    SollicitationsComplementsSchema,
    SollicitationsDcpSchema,
    SollicitationsAvisSchema,
    SollicitationsAvisPrealablesSchema,
    SollicitationsAttestationsSchema,
    SollicitationsJustificationsSchema,
]);
export const FormattedSollicitationsSchema = z.discriminatedUnion('type', [
    FormattedSollicitationsComplementsSchema,
    FormattedSollicitationsDcpSchema,
    FormattedSollicitationsAvisSchema,
    FormattedSollicitationsAvisPrealablesSchema,
    FormattedSollicitationsAttestationsSchema,
    FormattedSollicitationsJustificationsSchema,
]);
//# sourceMappingURL=sollicitations.js.map